import ConstructiveButton from '@/features/common/buttons/ConstructiveButton'
import DestructiveButton from '@/features/common/buttons/DestructiveButton'
import { padding } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/styles'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface OrderFinalizationTransitionActionsProps {
    onCancel: () => void
    onContinue: () => void
}

const OrderFinalizationTransitionActions: FC<OrderFinalizationTransitionActionsProps> = ({
    onCancel,
    onContinue,
}) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            <DestructiveButton icon onPress={onCancel} style={styles.closeButton} />
            <ConstructiveButton
                onPress={onContinue}
                style={styles.button}
                textStyle={styles.buttonText}
            >
                {t('actions.continue')}
            </ConstructiveButton>
            <View style={styles.placeholder} />
        </View>
    )
}

const iconButtonSize = 44

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        paddingHorizontal: padding,
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
    },
    button: {
        height: iconButtonSize,
        flexGrow: 1,
        maxWidth: '100%',
    },
    placeholder: {
        height: iconButtonSize,
        width: iconButtonSize,
    },
    closeButton: {
        width: iconButtonSize,
        height: iconButtonSize,
        maxWidth: iconButtonSize,
        flexGrow: 0,
        paddingHorizontal: 0,
        justifyContent: 'center',
        gap: 0,
    },
    buttonText: {
        textTransform: 'uppercase',
    },
})

export default OrderFinalizationTransitionActions
